import { createRouter } from '@tanstack/react-router';
import { accountRoute } from './routes/account';
import { authCallbackRoute } from './routes/auth-callback';
import { authStartRoute } from './routes/auth-start';
import { caseDetailRoute } from './routes/case-detail';
import { casesRoute } from './routes/cases-list';
import { indexRoute } from './routes/index';
import { loginRoute } from './routes/login';
import { rootRoute } from './routes/root';

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  authStartRoute,
  authCallbackRoute,
  casesRoute,
  caseDetailRoute,
  accountRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
